import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _scaleMap, _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ScaleTypes, StyleScaleType } from '@antv/l7-core';
import { extent } from 'd3-array';
import * as d3interpolate from 'd3-interpolate';
import * as d3 from 'd3-scale';
import { injectable } from 'inversify';
import { isNil, isString, uniq } from 'lodash';
import 'reflect-metadata';
import identity from "../utils/identityScale";
var dateRegex = /^(?:(?!0000)[0-9]{4}([-/.]+)(?:(?:0?[1-9]|1[0-2])\1(?:0?[1-9]|1[0-9]|2[0-8])|(?:0?[13-9]|1[0-2])\1(?:29|30)|(?:0?[13578]|1[02])\1(?:31))|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)([-/.]?)0?2\2(?:29))(\s+([01]|([01][0-9]|2[0-3])):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9]))?$/;
var scaleMap = (_scaleMap = {}, _defineProperty(_scaleMap, ScaleTypes.LINEAR, d3.scaleLinear), _defineProperty(_scaleMap, ScaleTypes.POWER, d3.scalePow), _defineProperty(_scaleMap, ScaleTypes.LOG, d3.scaleLog), _defineProperty(_scaleMap, ScaleTypes.IDENTITY, identity), _defineProperty(_scaleMap, ScaleTypes.SEQUENTIAL, d3.scaleSequential), _defineProperty(_scaleMap, ScaleTypes.TIME, d3.scaleTime), _defineProperty(_scaleMap, ScaleTypes.QUANTILE, d3.scaleQuantile), _defineProperty(_scaleMap, ScaleTypes.QUANTIZE, d3.scaleQuantize), _defineProperty(_scaleMap, ScaleTypes.THRESHOLD, d3.scaleThreshold), _defineProperty(_scaleMap, ScaleTypes.CAT, d3.scaleOrdinal), _defineProperty(_scaleMap, ScaleTypes.DIVERGING, d3.scaleDiverging), _scaleMap);
/**
 * 根据 Source 原始数据为指定字段创建 Scale，保存在 StyleAttribute 上，供下游插件使用
 */

var FeatureScalePlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function FeatureScalePlugin() {
    _classCallCheck(this, FeatureScalePlugin);

    _defineProperty(this, "scaleOptions", {});
  }

  _createClass(FeatureScalePlugin, [{
    key: "apply",
    value: function apply(layer, _ref) {
      var _this = this;

      var styleAttributeService = _ref.styleAttributeService;
      layer.hooks.init.tapPromise('FeatureScalePlugin', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _layer$getSource;

        var attributes, dataArray;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.scaleOptions = layer.getScaleOptions();
                attributes = styleAttributeService.getLayerStyleAttributes();
                dataArray = (_layer$getSource = layer.getSource()) === null || _layer$getSource === void 0 ? void 0 : _layer$getSource.data.dataArray;

                if (!(Array.isArray(dataArray) && dataArray.length === 0)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _this.caculateScalesForAttributes(attributes || [], dataArray);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))); // 检测数据是否需要更新

      layer.hooks.beforeRenderData.tapPromise('FeatureScalePlugin', /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(flag) {
          var attributes, dataArray;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (flag) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", flag);

                case 2:
                  _this.scaleOptions = layer.getScaleOptions();
                  attributes = styleAttributeService.getLayerStyleAttributes();
                  dataArray = layer.getSource().data.dataArray;

                  if (!(Array.isArray(dataArray) && dataArray.length === 0)) {
                    _context2.next = 7;
                    break;
                  }

                  return _context2.abrupt("return", true);

                case 7:
                  _this.caculateScalesForAttributes(attributes || [], dataArray);

                  layer.layerModelNeedUpdate = true;
                  return _context2.abrupt("return", true);

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
      layer.hooks.beforeRender.tap('FeatureScalePlugin', function () {
        if (layer.layerModelNeedUpdate) {
          return;
        }

        _this.scaleOptions = layer.getScaleOptions();
        var attributes = styleAttributeService.getLayerStyleAttributes();
        var dataArray = layer.getSource().data.dataArray;

        if (Array.isArray(dataArray) && dataArray.length === 0) {
          return;
        }

        if (attributes) {
          var attributesToRescale = attributes.filter(function (attribute) {
            return attribute.needRescale;
          });

          if (attributesToRescale.length) {
            _this.caculateScalesForAttributes(attributesToRescale, dataArray);
          }
        }
      });
    }
  }, {
    key: "isNumber",
    value: function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }, {
    key: "caculateScalesForAttributes",
    value: function caculateScalesForAttributes(attributes, dataArray) {
      var _this2 = this;

      attributes.forEach(function (attribute) {
        if (attribute.scale) {
          // 创建Scale
          var attributeScale = attribute.scale; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

          attributeScale.names = _this2.parseFields(attribute.scale.field || []);
          var scales = []; // 为每个字段创建 Scale

          attributeScale.names.forEach(function (field) {
            var _attribute$scale;

            scales.push(_this2.createScale(field, attribute.name, (_attribute$scale = attribute.scale) === null || _attribute$scale === void 0 ? void 0 : _attribute$scale.values, dataArray));
          }); // 为scales 设置值区间 Range

          if (scales.some(function (scale) {
            return scale.type === StyleScaleType.VARIABLE;
          })) {
            attributeScale.type = StyleScaleType.VARIABLE;
            scales.forEach(function (scale) {
              var _scale$option;

              // 如果设置了回调, 这不需要设置range
              if (!attributeScale.callback && attributeScale.values !== 'text') {
                switch ((_scale$option = scale.option) === null || _scale$option === void 0 ? void 0 : _scale$option.type) {
                  case ScaleTypes.LOG:
                  case ScaleTypes.LINEAR:
                  case ScaleTypes.POWER:
                    if (attributeScale.values && attributeScale.values.length > 2) {
                      var tick = scale.scale.ticks(attributeScale.values.length);
                      scale.scale.domain(tick);
                    }

                    attributeScale.values ? scale.scale.range(attributeScale.values) : scale.scale.range(scale.option.domain);
                    break;

                  case ScaleTypes.QUANTILE:
                  case ScaleTypes.QUANTIZE:
                  case ScaleTypes.THRESHOLD:
                    scale.scale.range(attributeScale.values); //

                    break;

                  case ScaleTypes.IDENTITY:
                    // 不做处理xe
                    break;

                  case ScaleTypes.CAT:
                    attributeScale.values ? scale.scale.range(attributeScale.values) : scale.scale.range(scale.option.domain);
                    break;

                  case ScaleTypes.DIVERGING:
                  case ScaleTypes.SEQUENTIAL:
                    scale.scale.interpolator( // @ts-ignore
                    d3interpolate.interpolateRgbBasis(attributeScale.values));
                    break;
                }
              }

              if (attributeScale.values === 'text') {
                var _scale$option2;

                scale.scale.range((_scale$option2 = scale.option) === null || _scale$option2 === void 0 ? void 0 : _scale$option2.domain);
              }
            });
          } else {
            // 设置attribute 常量值 常量直接在value取值
            attributeScale.type = StyleScaleType.CONSTANT;
            attributeScale.defaultValues = scales.map(function (scale, index) {
              return scale.scale(attributeScale.names[index]);
            });
          }

          attributeScale.scalers = scales.map(function (scale) {
            return {
              field: scale.field,
              func: scale.scale,
              option: scale.option
            };
          });
          attribute.needRescale = false;
        }
      });
    }
    /**
     * @example
     * 'w*h' => ['w', 'h']
     * 'w' => ['w']
     */

  }, {
    key: "parseFields",
    value: function parseFields(field) {
      if (Array.isArray(field)) {
        return field;
      }

      if (isString(field)) {
        return field.split('*');
      }

      return [field];
    }
  }, {
    key: "createScale",
    value: function createScale(field, name, values, data) {
      var _this$scaleOptions$na, _find;

      // scale 支持根据视觉通道和字段
      var scaleOption = this.scaleOptions[name] && ((_this$scaleOptions$na = this.scaleOptions[name]) === null || _this$scaleOptions$na === void 0 ? void 0 : _this$scaleOptions$na.field) === field ? this.scaleOptions[name] // TODO  zi
      : this.scaleOptions[field];
      var styleScale = {
        field: field,
        scale: undefined,
        type: StyleScaleType.VARIABLE,
        option: scaleOption
      };

      if (!data || !data.length) {
        if (scaleOption && scaleOption.type) {
          styleScale.scale = this.createDefaultScale(scaleOption);
        } else {
          styleScale.scale = d3.scaleOrdinal([field]);
          styleScale.type = StyleScaleType.CONSTANT;
        }

        return styleScale;
      } // eslint-disable-next-line @typescript-eslint/no-non-null-assertion


      var firstValue = (_find = data.find(function (d) {
        return !isNil(d[field]);
      })) === null || _find === void 0 ? void 0 : _find[field]; // 常量 Scale

      if (this.isNumber(field) || isNil(firstValue) && !scaleOption) {
        styleScale.scale = d3.scaleOrdinal([field]);
        styleScale.type = StyleScaleType.CONSTANT;
      } else {
        // 根据数据类型判断 默认等分位，时间，和枚举类型
        var type = scaleOption && scaleOption.type || this.getDefaultType(firstValue);

        if (values === 'text') {
          // text 为内置变 如果是文本则为cat
          type = ScaleTypes.CAT;
        }

        var cfg = this.createScaleConfig(type, field, scaleOption, data);
        styleScale.scale = this.createDefaultScale(cfg);
        styleScale.option = cfg;
      }

      return styleScale;
    }
  }, {
    key: "getDefaultType",
    value: function getDefaultType(firstValue) {
      var type = ScaleTypes.LINEAR;

      if (typeof firstValue === 'string') {
        type = dateRegex.test(firstValue) ? ScaleTypes.TIME : ScaleTypes.CAT;
      }

      return type;
    } // 生成Scale 默认配置

  }, {
    key: "createScaleConfig",
    value: function createScaleConfig(type, field, scaleOption, data) {
      var cfg = {
        type: type
      };
      var values = (data === null || data === void 0 ? void 0 : data.map(function (item) {
        return item[field];
      })) || [];

      if (scaleOption !== null && scaleOption !== void 0 && scaleOption.domain) {
        cfg.domain = scaleOption === null || scaleOption === void 0 ? void 0 : scaleOption.domain;
      } else if (type === ScaleTypes.CAT || type === ScaleTypes.IDENTITY) {
        cfg.domain = uniq(values);
      } else if (type === ScaleTypes.QUANTILE) {
        cfg.domain = values;
      } else if (type === ScaleTypes.DIVERGING) {
        var minMax = extent(values);
        var neutral = (scaleOption === null || scaleOption === void 0 ? void 0 : scaleOption.neutral) !== undefined ? scaleOption === null || scaleOption === void 0 ? void 0 : scaleOption.neutral : (minMax[0] + minMax[1]) / 2;
        cfg.domain = [minMax[0], neutral, minMax[1]];
      } else {
        // linear/Power/log
        cfg.domain = extent(values);
      }

      return _objectSpread(_objectSpread({}, cfg), scaleOption);
    } // 创建Scale 实例

  }, {
    key: "createDefaultScale",
    value: function createDefaultScale(_ref4) {
      var type = _ref4.type,
          domain = _ref4.domain,
          unknown = _ref4.unknown,
          clamp = _ref4.clamp,
          nice = _ref4.nice;
      // @ts-ignore
      var scale = scaleMap[type]();

      if (domain && scale.domain) {
        scale.domain(domain);
      }

      if (unknown) {
        scale.unknown(unknown);
      }

      if (clamp !== undefined && scale.clamp) {
        scale.clamp(clamp);
      }

      if (nice !== undefined && scale.nice) {
        scale.nice(nice);
      } // TODO 其他属性支持


      return scale;
    }
  }]);

  return FeatureScalePlugin;
}()) || _class);
export { FeatureScalePlugin as default };